import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectedModifiersArray'
})
export class SelectedModifiersArrayPipe implements PipeTransform {
  transform(
    collection: Array<any>,
    prefix = 'Adding: ',
    showCount = false
  ): string {
    if (!collection || collection?.length === 0) return '';

    const modifierArray = collection
      .map((x) => {
        const { modifierName, selectedValue } = x;
        const count = showCount && selectedValue ? `${selectedValue}x ` : '';  
        return `${count}${modifierName.trim()}`;
      })
      .join(', ');

    return `${prefix}${modifierArray}`;
  }
}
